import Vue from 'vue';
import Router from 'vue-router';

import Introduction from "@/components/common/Introduction";
import videoTrain from "@/components/common/videoTrain";
import notVerify from "@/components/dataUpLoad/notVerify";
import alreadyVerify from "@/components/dataUpLoad/alreadyVerify";
import returnVerify from "@/components/dataUpLoad/returnVerify";

import login from "@/components/user/login";
import register from "@/components/user/register";
import Home from "@/components/Home";

import cityManage from "@/components/management/cityManage";
import dataManage from "@/components/management/dataManage";
import indexManage from "@/components/management/indexManage";
import calculateScore from "@/components/management/calculateScore";

import changeDataSearch from "@/components/search/changeDataSearch";
import compareDataSearch from "@/components/search/compareDataSearch";
import detailDataSearch from "@/components/search/detailDataSearch";
import rateRankSearch from "@/components/search/rateRankSearch";
import rateSystemSearch from "@/components/search/rateSystemSearch";

import dataUpload from "@/components/dataUpLoad/dataUpload";
import dataVerifyNav from "@/components/dataUpLoad/dataVerifyNav";

import userChange from "@/components/user/userChange";
import userModify from "@/components/user/userModify";
import passwordModify from "@/components/user/passwordModify";

import videoPlay from "@/components/common/videoPlay";

Vue.use(Router)
export default new Router({
    mode: 'history',
    routes: [{
            path: '/Home',
            name: 'Home',
            component: Home,
            redirect:'/Introduction',
            children:[
                {
                    path:'/Introduction',
                    name: 'Introduction',
                    component: Introduction,
                    meta:{
                        title:'系统介绍'
                    }
                },
                {
                    path:'/videoTrain',
                    name: 'videoTrain',
                    component: videoTrain,
                    meta:{
                        title:'培训视频'
                    }
                },
                {
                    path: '/changeDataSearch',
                    name: 'changeDataSearch',
                    component: changeDataSearch,
                    meta:{
                        title:'城市数据变化趋势分析'
                    }
                },
                {
                    path: '/compareDataSearch',
                    name: 'compareDataSearch',
                    component: compareDataSearch,
                    meta:{
                        title:'城市数据对比分析'
                    }
                },
                {
                    path: '/detailDataSearch',
                    name: 'detailDataSearch',
                    component: detailDataSearch,
                    meta:{
                        title:'城市详细数据查询'
                    }
                },
                {
                    path: '/rateRankSearch',
                    name: 'rateRankSearch',
                    component: rateRankSearch,
                    meta:{
                        title:'城市指标排名查询'
                    }
                },
                {
                    path: '/rateSystemSearch',
                    name: 'rateSystemSearch',
                    component: rateSystemSearch,
                    meta:{
                        title:'城市评价体系查询'
                    }
                },

                {
                    path: '/cityManage',
                    name: 'cityManage',
                    component: cityManage,
                    meta:{
                        title:'城市管理'
                    }
                },
                {
                    path: '/dataManage',
                    name: 'dataManage',
                    component: dataManage,
                    meta:{
                        title:'数据管理'
                    }
                },
                {
                    path: '/indexManage',
                    name: 'indexManage',
                    component: indexManage,
                    meta:{
                        title:'指标管理'
                    }
                },
                {
                    path: '/calculateScore',
                    name: 'calculateScore',
                    component: calculateScore,
                    meta:{
                        title:'指标得分计算'
                    }
                },
                {
                    path: '/dataVerifyNav',
                    name: 'dataVerifyNav',
                    component: dataVerifyNav,
                    redirect:'/notVerify',
                    children:[
                        {
                            path: '/notVerify',
                            name: 'notVerify',
                            component: notVerify,
                            meta:{
                                title:'未审核'
                            }
                        },
                        {
                            path: '/alreadyVerify',
                            name: 'alreadyVerify',
                            component: alreadyVerify,
                            meta:{
                                title:'已审核'
                            }
                        },
                        {
                            path: '/returnVerify',
                            name: 'returnVerify',
                            component: returnVerify,
                            meta:{
                                title:'已打回'
                            }
                        }
                    ]
                },
                {
                    path: '/dataUpload',
                    name: 'dataUpload',
                    component: dataUpload,
                    meta:{
                        title:'数据上传'
                    }
                },
                {
                    path: '/userChange',
                    name: 'userChange',
                    component: userChange,
                    meta:{
                        title:'用户权限修改'
                    }
                },
                {
                    path: '/userModify',
                    name: 'userModify',
                    component: userModify,
                    meta:{
                        title:'用户信息修改'
                    }
                },
                {
                    path: '/passwordModify',
                    name: 'passwordModify',
                    component: passwordModify,
                    meta:{
                        title:'用户密码修改'
                    }
                },
                {
                    path: '/video/:videoUrl',
                    name: 'videoPlay',
                    component: videoPlay,
                    props: true,
                    meta:{
                        title:'视频播放'
                    }
                }
            ]
        },
        {
        path: '/login',
        name: 'login',
        component: login,
            meta:{
                title:'登陆'
            }
        },
        {
            path: '/register',
            name: 'register',
            component: register,
            meta:{
                title:'注册'
            }
        }
    ]
})



